var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,0H5C3.3,0,2,1.3,2,3H1C0.4,3,0,3.4,0,4s0.4,1,1,1h1v2H1C0.4,7,0,7.4,0,8s0.4,1,1,1h1v2H1c-0.6,0-1,0.4-1,1 s0.4,1,1,1h1v2H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h1v2H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h1c0,1.7,1.3,3,3,3h6c2.8,0,5-2.2,5-5V5 C16,2.2,13.8,0,11,0z M14,19c0,1.7-1.3,3-3,3H5c-0.6,0-1-0.4-1-1V3c0-0.6,0.4-1,1-1h6c1.7,0,3,1.3,3,3V19z M12,7c0,0.6-0.4,1-1,1H7 C6.4,8,6,7.6,6,7s0.4-1,1-1h4C11.6,6,12,6.4,12,7z M21,0c-1.7,0-3,1.3-3,3v16.8c0,1.1,0.4,2.1,1.2,2.8l1.1,1.1 c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3l1.1-1.1c0.7-0.7,1.2-1.8,1.2-2.8V3C24,1.3,22.7,0,21,0z M22,19.8c0,0.5-0.2,1-0.6,1.4 L21,21.6l-0.4-0.4c-0.4-0.4-0.6-0.9-0.6-1.4V3c0-0.6,0.4-1,1-1s1,0.4,1,1V19.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.904ae74665979b5eef0465ced1c34737.svg";
export { ForwardRef as ReactComponent };